import PropTypes from "prop-types";
import TemplateDesignEditor from "../../../components/TemplateDesignEditor";

export default function StepDesign({ formData, setFormData }) {
	return (
		<div className="bg-slate-900/50 backdrop-blur border border-white/5 rounded-xl p-6">
			<h2 className="text-lg font-semibold text-white mb-6">
				Identidade Visual & Aceitacao
			</h2>
			<TemplateDesignEditor
				theme={formData.theme}
				variables={formData.variables}
				acceptanceConfig={formData.acceptance_config}
				onAcceptanceChange={(acceptance_config) =>
					setFormData((prev) => ({ ...prev, acceptance_config }))
				}
				onChange={(variables, theme) =>
					setFormData((prev) => ({ ...prev, variables, theme }))
				}
			/>
		</div>
	);
}

StepDesign.propTypes = {
	formData: PropTypes.object.isRequired,
	setFormData: PropTypes.func.isRequired,
};
